import { render, staticRenderFns } from "./deckglCanvas.vue?vue&type=template&id=d9eae5ae&scoped=true&"
import script from "./deckglCanvas.vue?vue&type=script&lang=js&"
export * from "./deckglCanvas.vue?vue&type=script&lang=js&"
import style0 from "./deckglCanvas.vue?vue&type=style&index=0&id=d9eae5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9eae5ae",
  null
  
)

export default component.exports